import {
    IconArrowBackUp,
    IconBuildingWarehouse,
    IconCashRegister,
    IconCoin,
    IconFileCheck,
    IconFileText,
    IconHome,
    IconMailForward,
    IconReceipt,
    IconReceiptTax,
    IconRoute,
    IconSettings,
    IconShip,
    IconTransfer,
    IconTruckDelivery,
    IconUsersGroup,
} from "@tabler/icons-react";

/**
 * Un'icona per ogni cosa dell'applicazione, la stessa nel menu, nella home e nei pulsanti
 * delle liste: chi vede il camion sa che si parla di buoni, ovunque lo veda.
 */
export const AppIcons = {
    home: IconHome,
    contract: IconFileText,
    mad: IconTransfer,
    loadingOrder: IconTruckDelivery,
    ship: IconShip,
    storageReport: IconReceipt,
    customerReport: IconMailForward,
    priceList: IconCoin,
    tax: IconReceiptTax,
    settings: IconSettings,
    users: IconUsersGroup,

    /** Movimenti fra silos: il percorso della merce, distinto dal passaggio di mano della M.A.D. */
    movement: IconRoute,
    clearance: IconFileCheck,
    stock: IconBuildingWarehouse,
    reversal: IconArrowBackUp,

    /** Addebito di un onere: distinto dal report di magazzinaggio. */
    taxCharge: IconCashRegister,
};
